export default {
	loadedResources: 	[],
	airportsOpts: 		[],
	ratePlansOpts: 		[],
	zonedAreasOpts: 	[],
	destinationsOpts: 	[],
	suppliersOpts: 		[],
	serviceTypesOpts: 	[],
	salesChannelsOpts: 	[],
	transportUnitsOpts: [],
	userDriverOpts: 	[],
	countriesOpts: 		[],
	userSuppliersAccess:[],
	userPointOfSalesAccess:[],
	serviceTypesCategoriesOpts:[],
	currencyOpts: [
		{ value: "mxn", text: "MXN" },
		{ value: "usd", text: "USD" }
	],
	langOpts: [
		{ value: "es", text: "Español" },
		{ value: "en", text: "Ingles" }
	],
	transportServiceContactStatusOpts: [
		{ value: "noContacted", text: "No contactado" },
		{ value: "byCall", 		text: "Por llamada" },
		{ value: "byMail", 		text: "Por email" },
		{ value: "byApp", 		text: "Por App" },
		{ value: "byWhatsapp", 	text: "Por Whatsapp" },
		{ value: "byMsg", 		text: "Por mensaje texto" }
	],
	transportServiceStatusOpts: [
		{ value: "pending", 	text: "Pendiente",    class: "secondary" },
		{ value: "active", 		text: "Activo",       class: "default" },
		{ value: "noShow", 		text: "No show",      class: "info" },
		{ value: "noProvided", 	text: "No atendido",  class: "warning" },
		{ value: "canceled", 	text: "Cancelado",    class: "danger" },
		{ value: "done", 	   	text: "Realizado",    class: "success" },
		{ value: "partialCancellation", text: "Pre Cancelado", class: "partialCancellation" },
	],
	transportServiceTrackingStatusOpts: [
		{ value: "pending", text: "Por iniciar" },
		{ value: "onWayToPickup", text: "Rumbo a pickup" },
		{ value: "atPickup", text: "En lugar de pickup" },
		{ value: "onWayToDropoff", text: "Rumbo a dropoff" },
		{ value: "finished", text: "Completado" },
		{ value: "noShow", text: "Completado (No show)" }
	],
	transportServiceStatusClasses: {
		pending: 	"secondary",
		active: 	"default",
		canceled: 	"danger",
		noShow: 	"info",
		noProvided: "warning",
		done: 		"success",
		partialCancellation: "partialCancellation",
	},
	reservationStatusOpts: [
		{ value: "active",   text: "Activo" },
		{ value: "canceled", text: "Cancelado" }
	],
	tripOpts: [
		{ value: "A2H", text: "A2H" },
		{ value: "H2A", text: "H2A" },
		{ value: "P2P", text: "P2P" }
	],
	clearResources() {
		this.loadedResources 	= [];
		this.airportsOpts 		= [];
		this.ratePlansOpts 		= [];
		this.zonedAreasOpts 	= [];
		this.destinationsOpts 	= [];
		this.suppliersOpts 		= [];
		this.serviceTypesOpts 	= [];
		this.salesChannelsOpts 	= [];
		this.countriesOpts 		= [];
		this.pointOfSalesOpts 		= [];
		this.userSuppliersAccess 	= [];
		this.userPointOfSalesAccess = [];
		this.serviceTypesCategoriesOpts=[];
	},

	async fetchApi({
		vm,
		route,
		limit,
		itemValue,
		itemText,
		returnAll = false
	}) {
		try {
			const response = await vm.$root.api.get(`${route}`, {
				params: { limit }
			});
			if (returnAll) return response;
			const rows = response.data.rows || response.data;
			return rows.map(item => ({
				value: item[itemValue],
				text: item[itemText]
			}));
		} catch (error) {
			console.log(error);
			return [];
		}
	},

	async loadResourcesOpts({ vm, resourceNames, forceRefresh = false }) {
		for (const resourceName of resourceNames) {
			if (
				this.loadedResources.find(x => x === resourceName) &&
				!forceRefresh
			)
				return null;
			this.loadedResources.push(resourceName);
			if (resourceName === "suppliersOpts") {
				this.suppliersOpts = [];
				this.suppliersOpts = await this.fetchApi({
					vm,
					route: "/suppliers",
					limit: 100,
					itemValue: "id",
					itemText: "code"
				});
			}
			if (resourceName === "serviceTypesOpts") {
				this.serviceTypesOpts = [];
				this.serviceTypesOpts = await this.fetchApi({
					vm,
					route: "/service-types",
					limit: 100,
					itemValue: "id",
					itemText: "name"
				});
			}
			if (resourceName === "salesChannelsOpts") {
				this.salesChannelsOpts = [];
				this.salesChannelsOpts = await this.fetchApi({
					vm,
					route: "/options/sales-channels",
					limit: 100,
					itemValue: "id",
					itemText: "name"
				});
			}
			if (resourceName === "destinationsOpts") {
				this.destinationsOpts = [];
				this.destinationsOpts = await this.fetchApi({
					vm,
					route: "/destinations",
					limit: 100,
					itemValue: "id",
					itemText: "name"
				});
			}
			if (resourceName === "countriesOpts") {
				this.countriesOpts = [];
				this.countriesOpts = await this.fetchApi({
					vm,
					route: "/countries",
					limit: 250,
					itemValue: "id",
					itemText: "name"
				});
			}
			if (resourceName === "airportsOpts") {
				this.airportsOpts = [];
				this.airportsOpts = await this.fetchApi({
					vm,
					route: "/airports",
					limit: 250,
					itemValue: "id",
					itemText: "name"
				});
			}
			if (resourceName === "zonedAreasOpts") {
				this.zonedAreasOpts = [];
				this.zonedAreasOpts = await this.fetchApi({
					vm,
					route: "/resource/zoned-areas",
					limit: 250,
					itemValue: "id",
					itemText: "name"
				});
			}
			if (resourceName === "ratePlansOpts") {
				this.ratePlansOpts = [];
				this.ratePlansOpts = await this.fetchApi({
					vm,
					route: "/rate-plans",
					limit: 250,
					itemValue: "id",
					itemText: "name"
				});
			}
			if (resourceName === "transportUnitsOpts") {
				this.transportUnitsOpts = [];
				this.transportUnitsOpts = await this.fetchApi({
					vm,
					route: "/transport-units",
					limit: 250,
					itemValue: "id",
					itemText: "title"
				});
			}
			if (resourceName === "userDriverOpts") {
				const response = await this.fetchApi({
					vm,
					route: "/drivers",
					limit: 250,
					returnAll: true
				});
				this.userDriverOpts = [];
				this.userDriverOpts = response.data.rows.map(item => ({
					value: item.id,
					text: `${item.firstName} ${item.lastName}`
				}));
			}

			if(resourceName === "serviceTypesCategoriesOpts") {
				this.serviceTypesCategoriesOpts = [];
				this.serviceTypesCategoriesOpts = await this.fetchApi({
					vm,
					route: "/service-types-categories",
					limit: 2000,
					itemValue: "id",
					itemText: "name"
				});
			}

			if(resourceName === "userListSassAccess") {
				this.userSuppliersAccess = []
				this.userPointOfSalesAccess = []
				const response = await this.fetchApi({
					vm,
					route: "/user-list-access",
					limit: 1000,
					returnAll: true
				})

				this.userSuppliersAccess = response.data.suppliers?.map(item => ({
					value: item.id,
					text: item.name
				}))

				this.userPointOfSalesAccess = response.data.pointOfSales?.map(item => ({
					value: item.id,
					text: item.codename
				}))
			}
		}
	}
};
